export class ServiceProvider {
    id: string;
    name: string;
    uid?: string;
    addresses: Address[];
}

export class Address {
    id: string;
    street: string;
    no: string;
    zip: string;
    city: string;
    contacts: Contact[];
    tradeIds: string[];
}

export class Contact {
    id: string;
    name: string;
    phone: string;
    mail: string;
}

export class AuditCase {
    id: string;
    serviceProviderId: string;
    addressId: string;
    contactId: string;
    caseId: string;
    caseSubId: string;
    tradeId: string;
    service: string;
}

export class CaseInfo {
    results: AuditCase[];
    hasMore: boolean;
    totalCount: number;
}

export class ServiceProviderInfo {
    serviceProvider: ServiceProvider;
    auditCases: CaseInfo;
    repairCases: CaseInfo;
}

export class ProviderInfo {
    name: string;
    uid: string;
    tradeIds: string[];
    street: string;
    streetNo: string;
    zip: string;
    city: string;
    contactName: string;
    email: string;
    phone: string;
    auditCases: string[];
    repairCases: string[];
    auditCasesCount: number;
    repairCasesCount: number;
}

export class Trade {
    id: string;
    key: string;
    name: string;
}